import NiotaClassicApiService from '../../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
const getDeviceParsedPackets = async function (deviceId) {
  return NiotaClassicApiService.deviceFetchParsedPackets(deviceId, {
    limit: 1
  }).then(res => {
    return get(res, 'data.data');
  }).then(lastValues => {
    if (!lastValues) {
      return lastValues;
    }
    let result;
    Object.keys(lastValues).forEach(key => {
      if (!result) {
        result = {};
      }
      result[key] = get(lastValues, `${key}[0]`);
    });
    return result;
  }).catch(() => {
    return null;
  });
};
const getDevicePackets = async function (deviceId) {
  return NiotaClassicApiService.deviceFetchPackets(deviceId, 0, 1).then(res => {
    return get(res, 'data.packets[0]', {});
  }).then(packet => {
    if (!packet) {
      return packet;
    }
    let result = {};
    if (packet.source === 'raw') {
      result['value'] = {
        time: packet.source_time,
        variable: 'value',
        value: isObject(packet.parsed) ? JSON.stringify(packet.parsed) : packet.parsed
      };
    } else {
      const parsedPacket = get(packet, 'source_data.parsed_packet', {});
      Object.keys(parsedPacket).forEach(key => {
        result[key] = {
          time: packet.source_time,
          variable: key,
          value: isObject(parsedPacket[key]) ? JSON.stringify(parsedPacket[key]) : parsedPacket[key]
        };
      });
    }
    return result;
  }).catch(() => {
    return null;
  });
};
const getDeviceVariables = async function (deviceId, deviceTypeId) {
  let parser = await NiotaClassicApiService.deviceTypeGetDetails(deviceTypeId).then(res => {
    let parser = get(res, 'data.devicetype.parser.config.variables') || {};
    if (get(res, 'data.devicetype.parser.type') === 'multi') {
      parser = {};
      const parserKeys = Object.keys(get(res, 'data.devicetype.parser.config') || {}).filter(k => k !== '__switch');
      parserKeys.forEach(pKey => {
        if (isObject(get(res, `data.devicetype.parser.config.${pKey}.variables`))) {
          parser = {
            ...parser,
            ...(get(res, `data.devicetype.parser.config.${pKey}.variables`) || {})
          };
        }
      });
    }
    /* 
    ORIGIN: {
      "temperature": {
        "name": "temperature",
        "value_type": { // << MUST BE FILLED!
          "name": "°C"
        }
      }
    }
    TARGET: {
      "temperature": {
        "time": "2019-05-28T14:17:36.000Z",
        "value": 29.75,
        "value_type_name": "°C",
        "variable": "temperature"
      }
    } */
    Object.keys(parser).forEach(parserKey => {
      if (!parser[parserKey]['value_type']) {
        delete parser[parserKey];
      } else {
        parser[parserKey].variable = parserKey;
        parser[parserKey].value_type_name =
        // prefer to use the base-unit, as the value will be converted to that
        get(parser, `${parserKey}.value_type.base_unit`) || get(parser, `${parserKey}.value_type.name`);
        parser[parserKey].value = 'N/A';
      }
    });
    return parser;
  }).catch(() => {
    return null;
  });
  if (!parser) {
    parser = {};
  }
  let parsedPackets = await getDeviceParsedPackets.call(this, deviceId).catch(() => {
    return null;
  });
  if (!parsedPackets) {
    parsedPackets = await getDevicePackets.call(this, deviceId).catch(() => {
      return null;
    });
  }
  if (parser) {
    Object.keys(parser).forEach(variableKey => {
      if (parsedPackets[variableKey]) {
        parser[variableKey].value = parsedPackets[variableKey].value;
        parser[variableKey].time = parsedPackets[variableKey].time;
      }
    });
  }
  return parser;
};
export default {
  name: 'CoreDtwinStateIothubEdit',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: () => ({})
    },
    tenantId: {
      type: Number,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    }
  },
  data: function () {
    return {
      loading: false,
      // the current result-set for the autocomplete device search
      niotaDevices: [],
      loadingDevices: false,
      niotaDeviceSearch: '',
      selectedNiotaDevice: null,
      niotaDeviceVariableHeaders: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'value',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'milliseconds_ago',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }],
      niotaDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      // the retrieved variables for the selected device
      niotaDeviceVariables: null,
      selectedNiotaDeviceVariable: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    formIsValid() {
      return !isNullOrEmpty(this.selectedNiotaDevice) && !isNullOrEmpty(this.selectedNiotaDeviceVariable) && this.selectedNiotaDeviceVariable.length > 0;
    },
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    }
  },
  watch: {
    niotaDeviceSearch(val) {
      if (!val || val.length < 2) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `niotaDevices` to an array with only `selectedNiotaDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.niotaDevices = [this.selectedNiotaDevice].filter(d => d);
        return;
      }

      // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set
      if (!this.selectedNiotaDevice || !this.selectedNiotaDevice.title || val !== this.selectedNiotaDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    selectedNiotaDevice(val) {
      if (val !== null) {
        this.fetchVariables();
      }
      this.emitSelection();
    },
    selectedNiotaDeviceVariable() {
      this.emitSelection();
    }
  },
  created() {
    if (this.mode !== 'create' && this.mode !== 'import' && this.lclModel.properties.binding.options.identifier) {
      NiotaClassicApiService.deviceGetDetails(this.lclModel.properties.binding.options.identifier).then(res => {
        let device = get(res, 'data.device');
        if (!device || !device.id) {
          throw new Error('NIOTA_DEVICE_NOT_FOUND');
        }
        this.niotaDevices = device ? [device] : null;
        this.selectedNiotaDevice = device;
      }).catch(error => {
        console.error(get(error, 'response.status'));
        if (get(error, 'response.status') === 403) {
          // user has no permission to read the device
          // probably some other user linked it, and this user cannot read it
          // so emit the no-permission event here to trigger the edit-dialog to be closed
          this.$emit('no-permission', this.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));
          return;
        }
        console.error(error);
        let errorMessage = get(error, 'response.data.message', error.message);
        let errorOutput = this.$i18n_te(`Error.${errorMessage}`) ? this.$i18n_t(`Error.${errorMessage}`) : this.$i18n_t(errorMessage);
        this.$snack(errorOutput, 'error');
        this.niotaDevices = null;
        this.selectedNiotaDevice = null;
      }).finally(() => {
        this.loading = false;
      });
      this.selectedNiotaDeviceVariable = [{
        variable: this.lclModel.properties.binding.options.variable
      }];
    }
  },
  methods: {
    emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedNiotaDeviceVariable, '[0].value_type_name'),
        variable: get(this.selectedNiotaDeviceVariable, '[0].variable'),
        value: get(this.selectedNiotaDeviceVariable, '[0].value')
      });
    },
    fetchDevices: debounce(function () {
      this.loadingDevices = true;
      NiotaClassicApiService.devicesFind(this.niotaDeviceSearch, 0, 50, 'title', 'ASC').then(res => {
        // only allow devices with a devicetype, as otherwise there are no parsed variables to choose from
        this.niotaDevices = get(res, 'data.devices', []).filter(device => {
          return device.deviceTypeId;
        });
      }).catch(error => {
        console.error(error);
        let errorMessage = get(error, 'response.data.message', error.message);
        let errorOutput = this.$i18n_te(`Error.${errorMessage}`) ? this.$i18n_t(`Error.${errorMessage}`) : this.$i18n_t(errorMessage);
        this.$snack(errorOutput, 'error');
        this.niotaDevices = [];
      }).finally(() => {
        this.loadingDevices = false;
      });
    }, 250),
    fetchVariables() {
      this.niotaDeviceVariables = null;
      if (!get(this, 'selectedNiotaDevice.id') || !get(this, 'selectedNiotaDevice.deviceTypeId')) {
        return;
      }
      getDeviceVariables(this.selectedNiotaDevice.id, this.selectedNiotaDevice.deviceTypeId).then(variables => {
        const variableKeys = Object.keys(variables);
        this.niotaDeviceVariables = variableKeys.map(key => {
          const variable = variables[key];
          if (variable.time) {
            variable['milliseconds_ago'] = new Date() - new Date(variable.time);
            variable['time_ago'] = variable['milliseconds_ago'];
            const units = ['seconds', 'minutes', 'hours', 'days', 'months'];
            const conversion = [1000, 60, 60, 24, 30];
            let selectedUnit = 0;
            while (variable['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
              variable['time_ago'] = Math.floor(variable['time_ago'] / conversion[selectedUnit]);
              selectedUnit++;
            }
            selectedUnit--;
            variable['time_ago'] = `${variable['time_ago']} ${units[selectedUnit]}`;
          }
          return variable;
        });
      }).catch(error => {
        console.error(error);
        let errorMessage = get(error, 'response.data.message', error.message);
        let errorOutput = this.$i18n_te(`Error.${errorMessage}`) ? this.$i18n_t(`Error.${errorMessage}`) : this.$i18n_t(errorMessage);
        this.$snack(errorOutput, 'error');
        this.niotaDeviceVariables = [];
      });
    },
    saveState() {
      this.lclModel.properties.binding.options.identifier = get(this.selectedNiotaDevice, 'id');
      this.lclModel.properties.binding.options.variable = get(this.selectedNiotaDeviceVariable, '[0].variable');
    }
  }
};